import React from 'react'
import {useTranslation} from 'react-i18next'

import {
  SelectedGlobal,
  RescheduleFormCard,
  ButtonsRow,
  OrangeButton,
} from './AppointmentManagementPage.styled'

import {Typography} from '~/components/general/typography/Typography'
import {Container} from '~/components/general/container/Container'
import {TextArea} from '~/components/general/textArea/TextArea'

type CancelPanelProps = {
  dateLegend: string
  comment: string
  onChangeComment: (value: string) => void
  onBack: () => void
  onConfirm: () => void
}

export const CancelPanel = ({
  dateLegend,
  comment,
  onChangeComment,
  onBack,
  onConfirm,
}: CancelPanelProps) => {
  const {t} = useTranslation()

  return (
    <>
      <SelectedGlobal>
        <Typography size="xl" weight="bold">
          {dateLegend}
        </Typography>
      </SelectedGlobal>

      <RescheduleFormCard>
        <Container direction="column" spacing={2}>
          <Typography weight="bold">{t('Add a comment')}</Typography>
          <TextArea
            height="120px"
            placeholder={t('Write your reason for cancellation (optional)')}
            value={comment}
            onChange={(e) => onChangeComment(e.target.value)}
          />
          <ButtonsRow>
            <OrangeButton color="secondary" onClick={onBack}>
              {t('Back')}
            </OrangeButton>
            <OrangeButton onClick={onConfirm}>{t('Confirm')}</OrangeButton>
          </ButtonsRow>
        </Container>
      </RescheduleFormCard>
    </>
  )
}
